import React from 'react';
import { ProcessStep as ProcessStepType } from '../../types';

interface ProcessStepProps {
  step: ProcessStepType;
  index: number;
}

const ProcessStep: React.FC<ProcessStepProps> = ({ step, index }) => {
  return (
    <div className="relative h-full">
      <div className="bg-white rounded-lg p-6 shadow-md relative z-10 h-full flex flex-col">
        <div className="bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
          <step.icon size={24} />
        </div>
        <h3 className="text-lg font-semibold text-center mb-2">{step.title}</h3>
        <p className="text-gray-600 text-center text-sm flex-grow">{step.description}</p>
      </div>
      <div className="hidden md:flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-blue-600 rounded-full items-center justify-center text-white font-bold">
        {index + 1}
      </div>
    </div>
  );
};

export default ProcessStep;